/*=========================================================================================
  File Name: moduleCustomer.js
  Description: Customer Module
  ----------------------------------------------------------------------------------------
  Item Name: POS SYSTEM
  Author: SpeedCodeLabs
  Author URL: http://www.speedcodelabs.com
==========================================================================================*/

import state from './moduleEventState';
import mutations from './moduleEventMutations';
import actions from './moduleEventActions';
import getters from './moduleEventGetters';

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
